<template>
    <html data-wf-page="5b17a0c3e17ccd5653bd4f4e" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Dashboard</title>
  <meta content="Cabinet Manager | Dashboard" property="og:title">
  <meta content="width=device-width, initial-scale=1" name="viewport">
</head>
<body class="body-2">
  <MobileNav :project="project" :current-page="'items'"></MobileNav>
  <div class="wholewrapper">
    <div class="div-block-24">
      <NavSideBar :current-page="'items'" :project="project"></NavSideBar>
      <div class="contentcontainer">
        <div class="contenttop">
          <div class="div-block-30">
            <div class="projectselector">
              <el-dropdown trigger="click" @command="switchProject" style="max-width:40vw">
                <span class="el-dropdown-link" style="color: #fff; font-weight: bold; word-wrap: break-word">{{ project.name }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="project in projectList"
                    v-if="project.status !== 'closed'"
                    :key="project.id"
                    :command="project.id">{{ project.name }}
                  </el-dropdown-item>
                  <el-dropdown-item divided
                    :command="''">All Projects
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <SignInButton :user="user" @login="$emit('login')"></SignInButton>
          </div>
          <div class="div-block-32">
            <div class="text-block-16">Project Item</div>
          </div>
        </div>
        <div class="contentdown">
          <div class="downcontentdrawings">
            <el-input v-model="queryString" placeholder="Search by ITEM NAME, COLOR or MEMO" style="width: 100%;"></el-input>
            <div class="data">
              <div class="item-container" v-for="(item, index) in displayedItems" :key="index">
                <div class="item-head">
                  <span class="item-name"> {{item.model}} </span>
                  <i class="material-icons" @click="editItem(item)">create</i>
                </div>
                <div class="item-color">
                  <span class="label"> Color Spec. &nbsp;</span>
                  <span class="tag-block" :style="`background-color: ${item.color ? item.color.tag : '#fff'}`"></span>
                  <span class="color-spec"> {{item.color ? item.color.color : ''}} </span>
                </div>
                <div class="item-remark" v-if="item.projectRemark">
                  <span class="label"> Memo. &nbsp; </span>
                  <span> {{item.projectRemark}} </span>
                </div>
              </div>
            </div>
            <div class="page-selector">
              <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                :current-page.sync="pageNum"
                :page-size.sync="itemsPerPage"
                :page-sizes="[10, 20, 50, 100]"
                :total="passedItems.length">
              </el-pagination>
            </div>
          </div>
          <div class="powereddiv">
            <div class="div-block-14">
              <div class="text-block-9">Powered by </div>
              <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
                <div class="text-block-10">Studio S, Inc.</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EditItemForm :item="editingItem" :project-id="currentProject" v-if="showEditItem" v-on:close-edit-item="showEditItem = false">
  </EditItemForm>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>

<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
import { db } from '../main'
import SignInButton from './SignInButton'
import NavSideBar from './NavSideBar'
import MobileNav from './MobileNav'
import EditItemForm from './EditItemForm'

export default {
  name: 'ProjectItem',
  props: ['user'],
  data () {
    return {
      dataReady: false,
      currentProject: "NO_PROJECT_SELECTED",
      projectList: [],
      project: {},
      remoteItems: [],
      remoteColors: [],
      pageNum: 1,
      itemsPerPage: 10,
      queryString: '',
      editingItem: {},
      showEditItem: false
    }
  },
  computed: {
    passedItems: function () {
      // the items can pass query filter
      if (!this.dataReady) {
        return []
      }
      // console.log('this.query =>', this.queryString)
      let queryString = this.queryString ? this.queryString.toLowerCase() : ''     // In case of querySting is null or undefined
      // console.log('query =>', queryString)
      let parsedItems = []
      let rawItems = this.remoteItems
      // console.log(rawItems)
      for (let item of rawItems) {
        let parsedItem = {
          itemId: item.itemId,
          model: item.model,
          projectRemark: item.projectRemark,
          glide: item.glide,
          handle: item.handle,
          hinge: item.hinge
        }
        parsedItem.color = fetchColorDetail(item.colorId, this.remoteColors)
        parsedItems.push(parsedItem)
      }
      // console.log(parsedItems)
      let passedItems = parsedItems.filter(item => {
        if (item.model.toLowerCase().indexOf(queryString) !== -1) {
          // console.log('MODEL MATCH')
          return true
        }
        if (item.color.color.toLowerCase().indexOf(queryString) !== -1) {
          // console.log('COLOR MATCH')
          return true
        }
        if (item.projectRemark.toLowerCase().indexOf(queryString) !== -1) {
          // console.log('MEMO MATCH')
          return true
        }
        return false
      })
      return passedItems
    },
    displayedItems: function () {
      // the items displayed on current page based on the page num
      let startIndex = (this.pageNum - 1) * this.itemsPerPage
      let endIndex = this.pageNum * this.itemsPerPage
      return this.passedItems.slice(startIndex, endIndex)
    }
  },
  firestore () {
    return {
      projectList: db.collection('project_list').where('version', '==', 2).orderBy('last_open_date','desc').limit(15)
    }
  },
  created: function () {
    this.currentProject = this.$route.query.project
    let initResult = this.initData()
    if (initResult) {
      // this.$notify({
      //   title: 'Success',
      //   message: 'Current project: ' + this.currentProject,
      //   type: 'success',
      //   duration: 3000,
      //   offset: 64
      // })
    }
  },
  watch: {
    $route: function () {
      this.currentProject = this.$route.query.project
    },
    currentProject: function () {
      // console.log('current project changed, link to new project')
      let initResult = this.initData()
      if (initResult) {
        // this.$notify({
        //   title: 'Success',
        //   message: 'Current project: ' + this.currentProject,
        //   type: 'success',
        //   duration: 3000,
        //   offset: 64
        // })
      }
    }
  },
  methods: {
    switchProject: function (projectId) {
      // console.log('switch to =>', projectId)
      if (projectId !== ''){
        this.$router.push({
          path: 'dashboard',
          query: {
            project: projectId
          }
        })
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    initData: async function () {
      this.dataReady = false
      if (this.currentProject === 'NO_PROJECT_SELECTED') {
        return false
      }
      this.$bind('project', db.collection('project').doc(this.currentProject))
      // console.log('Bind Items for project => ', this.currentProject)
      this.$bind('remoteItems', db.collection('items').where('projectId','==',this.currentProject).orderBy('model'))
      this.$bind('remoteColors', db.collection('colors').where('projectId','==',this.currentProject))
      this.dataReady = true
      return true
    },
    editItem: function (item) {
      this.editingItem = item
      this.showEditItem = true
    }
  },
  components: {
    SignInButton,
    NavSideBar,
    MobileNav,
    EditItemForm
  }
}
function fetchColorDetail (colorId, colors) {
  for (let color of colors) {
    if (color.colorId === colorId) {
      return {
        color: color.name,
        tag: color.tag
      }
    }
  }
}

</script>

<style scoped>
.data :last-child {
  border-bottom: none;
}
.data {
  width: 100%;
}
.item-container {
  padding: 24px 4px;
  width: 100%;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}
.item-color {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  margin-top: 4px;
  font-size: 14px;
}
.item-name {
  font-size: 18px;
}
.item-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.label {
  color: #aaaaaa;
  min-width: 90px;
  width: 90px;
}
.material-icons{
  color: #00838f;
  width: 18px;
  cursor: pointer;
}
.page-selector {
  text-align: center;
  margin-top: 36px;
}
.tag-block {
  display: inline-block;
  height: 12px;
  width: 12px;
  min-width: 12px;
  min-width: 12px;
  margin: 5px 8px 0 0;
}
.color-spec {
  box-sizing: border-box;
  margin-right: 10vw;
  font-size: 14px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectItem.vue